import {
    GET_GIFTCARD_PROVIDERS,
    GET_RESTAURANT_GIFTCARD_PROVIDER_SETTINGS,
    RESET_RESTAURANT_GIFTCARD_PROVIDER_SETTINGS,
    GET_RESTAURANT_GIFTCARD_PROVIDER_TYPE_ID
} from '../../../../actions/types';

const INITIAL_STATE = {
    giftCardProviders: [],
    restaurantGiftCardProvider: {},
    restaurantGiftCardProviderTypeId: {}
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_GIFTCARD_PROVIDERS:
            return {...state, giftCardProviders: action.payload};
        case GET_RESTAURANT_GIFTCARD_PROVIDER_SETTINGS:
            return {...state, restaurantGiftCardProvider: action.payload};
        case RESET_RESTAURANT_GIFTCARD_PROVIDER_SETTINGS:
            return {...state, restaurantGiftCardProvider: null};
        case GET_RESTAURANT_GIFTCARD_PROVIDER_TYPE_ID:
            return {...state, restaurantGiftCardProviderTypeId: action.payload};
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/restaurants/settings/service/GiftCardProviderReducer.js